import { Workflow, useGlobalController } from "@bcm-dev/bcms-vite";
import AuthorizedDevicesPage from "components/pages/AuthorizedDevicesPage";
import { MobileDevice, User } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <AuthorizedDevicesPage /> ];

/**
 * @function AuthorizedDevicesWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "Authorize Devices" page.
 * 
 * Setting constructor example for state captures:
 * Note that "mobileDevices" set here have to exist in the model.
 * 
 * document.dispatchEvent(new CustomEvent("force-workflow-state", {
        detail: { 
            value: { 
            mobileDevices: [
                { id: "1" },
                { id: "0" }
            ],
            user: {
                id: "some id",
                first: "some first name",
                last: "some last name",
                lastLogin: -1,
                phone: 1
            }
            } 
        } 
    }));
 */
export default function AuthorizedDevicesWorkflow(props) {
    const controller = useGlobalController();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Define the constructor function for forcing state through the 'force-workflow-state' event
    const constructor = record => {
        const mobileDevicesObj = record.mobileDevices ?? [];
        const mobileDevices = mobileDevicesObj.reduce((acc, deviceObj) => {
            const device = MobileDevice.initByID(deviceObj.id);
            acc.push(device);
            return acc;
        }, []);
        const userObj = record.user ?? {};
        const user = User.init({ ...value.user.record, ...userObj });
        const mobileDevicesProp = mobileDevices.length > 0 ? { mobileDevices: mobileDevices } : {};
        const userProp = Object.entries(userObj).length > 0 ? { user: user } : {};
        
        return {
            ...getDefault(controller),
            ...mobileDevicesProp,
            ...userProp
        }
    }

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } constructor={ constructor } />
}
// Return the steps of the workflows
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    return {}
};